(() => {
  if (customElements.get('abu-size-recommender')) return;
  const chart = [
    {size:'S',half:45.7,length:71.1},{size:'M',half:50.8,length:73.7},
    {size:'L',half:55.9,length:76.2},{size:'XL',half:61,length:78.7},
    {size:'2XL',half:66,length:81.3},{size:'3XL',half:71.1,length:83.8},
    {size:'4XL',half:76,length:86},{size:'5XL',half:81,length:89}
  ];
  class AbuSizeRecommender extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
      this.messages=JSON.parse(this.querySelector('[data-messages]').textContent);
      this.position=Number(this.dataset.sizePosition)-1;
      this.root=this.closest('#abushalab-product');
      this.unit='cm';
      this.result=this.querySelector('[data-result]');
      for(const kind of ['height','build'])this.querySelectorAll(`[data-${kind}]`).forEach(button=>button.addEventListener('click',()=>{
        this[kind]=Number(button.dataset[kind]);
        this.querySelectorAll(`[data-${kind}]`).forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        this.recommend();
      }));
      this.querySelectorAll('[data-unit]').forEach(button=>button.addEventListener('click',()=>{
        this.unit=button.dataset.unit; this.paint(); if(this.hasResult)this.recommend();
      }));
      this.querySelectorAll('[data-tab]').forEach(button=>button.addEventListener('click',()=>this.showTab(button.dataset.tab)));
      this.paint();
      this.querySelector('[data-chart]').addEventListener('click',()=>{
        const chart=this.root.querySelector('.abu-description-size-guide');
        if(chart)chart.open=true;
      });
      this.abort=new AbortController();
      this.root.addEventListener('click',e=>{
        if(e.target.closest('.fg-color-button')&&this.hasResult)this.recommend();
      },{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();this.ready=false;}
    showTab(tab){
      this.querySelectorAll('[data-tab]').forEach(b=>b.setAttribute('aria-expanded',String(b.dataset.tab===tab)));
      this.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==tab);
    }
    paint(){
      const factor=this.unit==='in'?2.54:1;
      const format=n=>(n/factor).toFixed(1)+' '+this.unit.toUpperCase();
      this.querySelectorAll('[data-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.unit===this.unit)));
      const labels=this.messages[this.unit==='in'?'height_inches':'height_labels'].split('|');
      this.querySelectorAll('[data-height]').forEach(b=>b.textContent=labels[Number(b.dataset.height)]);
      const offered=new Set(this.variants.map(v=>v.options[this.position]));
      this.querySelector('[data-rows]').innerHTML=chart.filter(r=>offered.has(r.size)).map(r=>`<tr><th>${r.size}</th><td>${format(r.half)}</td><td>${format(r.length)}</td></tr>`).join('');
    }
    recommend(){
      if(this.height===undefined||this.build===undefined)return;
      this.hasResult=true;
      const selected=this.root.querySelector('#fg-variant-id')?.value;
      const current=this.variants.find(v=>String(v.id)===selected);
      const compatible=this.variants.filter(v=>v.available&&(!current||v.options.every((o,i)=>i===this.position||o===current.options[i])));
      const index=[[0,1,2],[1,2,3],[2,3,4],[3,4,5]][this.height][this.build];
      const row=chart[Math.max(0,index-1)];
      if(!compatible.some(v=>v.options[this.position]===row.size)){this.result.textContent=this.messages.unavailable;return;}
      const factor=this.unit==='in'?2.54:1;
      const units=this.unit==='in'?'in':'cm';
      this.result.textContent=this.messages.result.replace('{size}',row.size).replace('{width}',(row.half/factor).toFixed(1)+' '+units)+' '+this.messages.length.replace('{length}',(row.length/factor).toFixed(1)+' '+units);
    }
  }
  customElements.define('abu-size-recommender',AbuSizeRecommender);
})();

